import MaterialEditor from './src/Editor.vue'
MaterialEditor.install = (Vue) => {
  Vue.component(MaterialEditor.name, MaterialEditor)
}
export default MaterialEditor



// WEBPACK FOOTER //
// ./packages/material-editor/index.js